import type { TermsOfServiceAgreementWUserData } from './termsOfService';

// https://github.com/riskledger/rl/blob/dev/proto/identity/v1/constants.go#L15C1-L15C1
export enum OrgStatus {
  ActiveOrg = 'active',
  UnconfirmedOrg = 'unconfirmed',
  DeletedOrg = 'deleted',
}

export enum OrganisationOwnershipStatus {
  Unclaimed = 'unclaimed',
  Claimed = 'claimed',
  Managed = 'managed',
}

// https://github.com/riskledger/rl/blob/dev/services/monolith/pkg/models/organisation.go#L28-L34
export enum FederationStatus {
  Standalone = 'standalone',
  Federated = 'federated',
}

// https://github.com/riskledger/rl/blob/dev/services/monolith/pkg/models/organisation.go#L15-L67
export type Organisation = {
  orgID: string;
  name: string;
  companyNumber: string;
  streetAddress: string;
  city: string;
  postalCode: string;
  location: string;
  sector: string;
  website: string;
  businessPhoneNumber: string;
  isSupplier: boolean;
  isClient: boolean;
  isFederated: boolean;
  isClientRestricted: boolean;
  createdAt: string;
  clientAt: string | null;
  status: OrgStatus;
  signupSourceType: string | null;
  signupSourceID: string | null;
  paid: boolean;
  tradingNames: string[];
  logoUrl: string;
  deletedAt: string | null;
  ownershipStatus: OrganisationOwnershipStatus;

  /**
   * @deprecated - use assessmentStatus.initialAssessmentComplete instead
   */
  initialAssessmentComplete: boolean;

  tosInfo: TermsOfServiceAgreementWUserData | null;
};

export type OrganisationContact = {
  name: string;
  emailAddress: string;
};
